<template>
  <div :class="['emd-form-group', `js${name}group`]" v-show="!this.hasConditions || this.conditions['display']">
    <label :class="['emd-label', required ? 'u-required' : '']">{{title}}</label>
    <textarea
      v-if="textType === 'textarea'"
      class="emd-input"
      rows="7"
      :required="required"
      :name="name"
      :value="value"
      :placeholder="placeholder"
      @input="onInput"
      @change="handleInput">
    </textarea>
    <input
      v-else
      class="emd-input"
      ref="input"
      type="text"
      :required="required"
      :name="name"
      :value="value"
      :maxlength="maxLength"
      :minlength="minLength"
      :placeholder="placeholder"
      @input="onInput"
      @change="handleInput"
    >
    <div :class="['emd-input-helper', `js${name}helper`]"></div>
  </div>
</template>
<script>
export default {
  name: 'EmdInputText',
  props: ['required', 'name', 'maxLength', 'minLength', 'title', 'value', 'onInput', 'attrs', 'conditionalEvents', 'conditionalActions'],
  data () {
    return {
      conditions: {}
    }
  },
  computed: {
    textType: function () {
      return this.attrs !== undefined ? this.attrs.type : false
    },
    placeholder: function () {
      if (this.attrs !== undefined) {
        if (this.attrs.placeholder !== undefined) { return this.attrs.placeholder }
      }
      return this.title
    },
    hasConditions: function () {
      return this.attrs && this.attrs.conditions
    },
    conditionsKeys: function () {
      return this.hasConditions && Object.keys(this.conditions)
    }
  },
  methods: {
    handleInput (event) {
      this.$emit('input', event.target.value)
    }
  },
  created () {
    if (this.hasConditions) {
      this.hasConditions.forEach(condition => {
        const mustContainsEvent = condition.events.must.length === 0 || condition.events.must
          .map(mustEvent => this.conditionalEvents.includes(mustEvent))
          .indexOf(false) < 0
        const shouldContainsEvent = condition.events.should.length === 0 || condition.events.should
          .map(shouldEvent => this.conditionalEvents.includes(shouldEvent))
          .indexOf(true) >= 0
        const mustNotContainsEvent = condition.events.not_must.length === 0 || condition.events.not_must
          .map(notMustEvent => this.conditionalEvents.includes(notMustEvent))
          .indexOf(true) < 0
        const shouldNotContainsEvent = condition.events.not_should.length === 0 || condition.events.not_should
          .map(notShouldEvent => this.conditionalEvents.includes(notShouldEvent))
          .indexOf(false) >= 0

        const mustContainsAction = condition.actions.must.length === 0 || condition.actions.must
          .map(mustAction => this.conditionalActions.includes(mustAction))
          .indexOf(false) < 0
        const shouldContainsAction = condition.actions.should.length === 0 || condition.actions.should
          .map(shouldAction => this.conditionalActions.includes(shouldAction))
          .indexOf(true) >= 0
        const mustNotContainsAction = condition.actions.not_must.length === 0 || condition.actions.not_must
          .map(notMustAction => this.conditionalActions.includes(notMustAction))
          .indexOf(false) < 0
        const shouldNotContainsAction = condition.actions.not_should.length === 0 || condition.actions.not_should
          .map(notShouldAction => this.conditionalActions.includes(notShouldAction))
          .indexOf(false) >= 0

        this.conditions[condition.type] = (mustContainsEvent && shouldContainsEvent && mustNotContainsEvent && shouldNotContainsEvent) && (mustContainsAction && shouldContainsAction && mustNotContainsAction && shouldNotContainsAction)
      })
    }
  }
}
</script>
